import { Actions } from './actions';

const { open: openInNewTab } = Actions;

export { openInNewTab };

export { newTabMiddleware } from './middlewares/newTabMiddleware';
